import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';

class SplitBillingProvider extends BaseApi {
	async updateList(data: Record<string, any>, serviceOrderId: number | null, itemId: number | null) {
		return this.post(`${this.apiPath}SaveSplitParty?serviceOrderId=${serviceOrderId}&itemId=${itemId}`, data);
	}

	async fetchCustomerType(customerId: number |null){
		return this.fetch(`${this.apiPath}FetchCustomerTypeByCustomerId?customerId=${customerId}`)
	}
	async checkIsCustomerDealerType(customerId: number |null){
		return this.fetch(`${this.apiPath}CheckIsCustomerDealerType?customerId=${customerId}`)
	}

	async checkPrimaryCustomerType(customerId: number |null){
		return this.fetch(`${this.apiPath}checkPrimaryCustomerType?customerId=${customerId}`)
	}

	async fetchSplitPartyNames(serviceOrderId: number | null){
		return this.fetch(`${this.apiPath}GetSplitPartyNames?serviceOrderId=${serviceOrderId}`)
	}

	async getPartyInvoicedDetails(serviceOrderId: number | null) {
		return this.fetch(`${this.apiPath}GetPartyInvoicedDetails?serviceOrderId=${serviceOrderId}`);
	}

	async getVatPercent(customerId: number | null){
		return this.fetch(`${this.apiPath}GetVatPercent?customerId=${customerId}`)
	}

	async getDnp(itemId: number | null){
		return this.fetch(`${this.apiPath}GetDnp?itemId=${itemId}`)
	}

	async getPartWarrantyPrice(itemId: number | null){
		return this.fetch(`${this.apiPath}GetPartWarrantyPrice?itemId=${itemId}`)
	}

	async getMrp(itemId: number | null){
		return this.fetch(`${this.apiPath}GetMrp?itemId=${itemId}`)
	}
	async getExtLaborCostPrice(itemId: number | null){
		return this.fetch(`${this.apiPath}GetExtLaborCostPrice?itemId=${itemId}`)
	}

	async getWarrentyRateLo(orderId: number | null, itemId: number | null){
		return this.fetch(`${this.apiPath}GetWarrentyRateLo?orderId=${orderId}&itemId=${itemId}`)
	}
	async getLaborWarrantyPrice(orderId: number | null, itemId: number | null){
		return this.fetch(`${this.apiPath}GetLaborWarrantyPrice?orderId=${orderId}&itemId=${itemId}`)
	}

	async getSplitPartyForOrder(orderId: number) {
		return this.fetch(`${this.apiPath}GetSplitPartyForOrder?orderId=${orderId}`);
	}

	async getDropdownListForInternalSplit() {
		return this.fetch(`${this.apiPath}GetDropDownListforSplitBilling`);
	}
}

export const apiProvider = new SplitBillingProvider(DMS_MODULE, NAME);
